import { FC } from 'react';
import { Control } from 'react-hook-form';
import { InitialValues } from '../schema';
import NewBorrowerFormFieldset from '../NewBorrowerFormFieldset';
import { DialogContentText, Grid } from '@mui/material';
import InputField from '../../../../hook_form_fields/InputField';
import NumberField from '../../../../hook_form_fields/NumberField';
import RadioGroupField from '../../../../hook_form_fields/RadioGroupField';
import { NUMBER_FORMATS, PLACEHOLDERS, YES_NO } from '../../../../../constants';

const BusinessContactInformationFieldset: FC<{
  control: Control<InitialValues>;
}> = ({ control }) => {
  return (
    <NewBorrowerFormFieldset title="Business Contact Information">
      <Grid container maxWidth="md" spacing={2}>
        <Grid item xs={12} sm={12}>
          <InputField
            data-testid="businessName"
            control={control}
            name="borrower.name"
            label="Business Name"
            required
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <RadioGroupField
            data-testid="isNonProfit"
            control={control}
            name="application.is_flagged_non_profit_by_installer"
            label="Is this business a non-profit?"
            choices={YES_NO}
            required
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <DialogContentText
            sx={{
              backgroundColor: '#F4F4F4',
              color: 'black',
              padding: 0.5,
              borderRadius: '5px',
              fontSize: '0.85rem',
            }}
          >
            The contact person below is the party responsible for filling out
            the project loan application. Sunstone Credit will reach out to the
            responsible party within 24 hours of the application being created
            to assist them with completing the application. Please ensure the
            contact person is ready to start their application before clicking
            &quot;Add&quot;.
          </DialogContentText>
        </Grid>
        <Grid item xs={6} sm={6}>
          <InputField
            control={control}
            name="contact.first_name"
            label="Contact First Name"
            data-testid="firstName"
            required
            fullWidth
          />
        </Grid>
        <Grid item xs={6} sm={6}>
          <InputField
            control={control}
            name="contact.last_name"
            data-testid="lastName"
            label="Contact Last Name"
            required
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <InputField
            control={control}
            name="contact.position_title"
            data-testid="positionTitle"
            label="Contact Position/Title"
            required
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            control={control}
            name="contact.email"
            label="Contact Email"
            data-testid="email"
            trimWhitespace
            required
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <NumberField
            format={NUMBER_FORMATS.PHONE}
            placeholder={PLACEHOLDERS.PHONE}
            control={control}
            name="contact.phone"
            data-testid="phone"
            label="Contact Phone Number"
            allowLeadingZeros
            required
            fullWidth
          />
        </Grid>
      </Grid>
    </NewBorrowerFormFieldset>
  );
};

export default BusinessContactInformationFieldset;
